<template>
  <div class="base-info-groups">
    <div v-for="group in groups" :key="group.title" class="base-info-group">
      <div class="group-title">{{ group.title }}</div>
      <div class="info-grid">
        <div
          v-for="field in group.fields"
          :key="field.label"
          class="info-item"
          :class="{ wide: field.wide }"
        >
          <span>{{ field.label }}</span>
          <strong>{{ field.value }}</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    groups() {
      return [
        {
          title: '儿童信息',
          fields: [
            { label: '诊疗卡号', value: this.value('archives_num') },
            { label: '儿童姓名', value: this.value('name') },
            { label: '儿童性别', value: this.genderLabel },
            { label: '出生日期', value: this.value('born_date') },
            { label: '实际年龄', value: this.value('real_age') },
            { label: '所在年级', value: this.value('grade') },
            { label: '家长文化', value: this.value('parent_culture') },
            { label: '少数民族', value: this.minorityLabel },
          ],
        },
        {
          title: '测评信息',
          fields: [
            { label: '记分编号', value: this.value('scoring_num') },
            { label: '主试姓名', value: this.value('examiner_name') },
            { label: '测试日期', value: this.value('test_date') },
            { label: '测试地点', value: this.value('exam_address') },
            { label: '用手习惯', value: this.handHabitLabel },
            { label: '备注说明', value: this.value('remark'), wide: true },
          ],
        },
      ];
    },
    genderLabel() {
      if (String(this.data.gender) === '1') return '男';
      if (String(this.data.gender) === '2') return '女';
      return '-';
    },
    minorityLabel() {
      if (String(this.data.is_minorities) === '1') return '否';
      if (String(this.data.is_minorities) === '2') return '是';
      return '-';
    },
    handHabitLabel() {
      if (String(this.data.hand_habit) === '1') return '左手';
      if (String(this.data.hand_habit) === '2') return '右手';
      return '-';
    },
  },
  methods: {
    value(key) {
      const value = this.data[key];
      return value === null || value === undefined || value === '' ? '-' : value;
    },
  },
};
</script>

<style scoped>
.base-info-groups {
  display: grid;
  gap: 18px;
}

.group-title {
  margin-bottom: 9px;
  color: #5d666d;
  font-size: 13px;
  font-weight: 600;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border-top: 1px solid #e1e5e7;
  border-left: 1px solid #e1e5e7;
  border-radius: 6px;
  overflow: hidden;
}

.info-item {
  min-height: 72px;
  display: flex;
  justify-content: center;
  padding: 14px 16px;
  border-right: 1px solid #e1e5e7;
  border-bottom: 1px solid #e1e5e7;
  background: #fff;
  flex-direction: column;
}

.info-item.wide {
  grid-column: span 3;
}

.info-item span {
  color: #8a939a;
  font-size: 12px;
}

.info-item strong {
  overflow-wrap: anywhere;
  margin-top: 7px;
  color: #27313a;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

@media (max-width: 900px) {
  .info-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .info-item.wide {
    grid-column: span 1;
  }
}

@media (max-width: 600px) {
  .info-grid {
    grid-template-columns: 1fr;
  }
}
</style>
